import axios from 'axios'
import store from '../store'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  getManageThirdPartyVendors({ state }) {
    return axios
      .get(`${appConfig.apiEndPoint}${endpoint.adminApiPath.getallcras}`, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getReportingAgenctData({ state }, { craId } = {}) {
    console.log(craId)
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getcradetails}/${craId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  updateThirdPartyVendors({ state }, { updateCRAdata } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.editcradetails}`,
        updateCRAdata,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
